import { render, staticRenderFns } from "./AllBaOperatorBidWanted.vue?vue&type=template&id=386f46da&"
import script from "./AllBaOperatorBidWanted.vue?vue&type=script&lang=js&"
export * from "./AllBaOperatorBidWanted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports